import { useMemo } from "react";
import { matchPath, useLocation, type PathMatch } from "react-router-dom";

export function matchAnyPath<S extends string>(paths: S[], pathname: string, end = false): PathMatch<S> | null {
  for (const path of paths) {
    const match = matchPath({ path, end }, pathname);
    if (match) return match as unknown as PathMatch<S>;
  }
  return null;
}

export function useMatchAny<S extends string>(paths: S[], end = false): PathMatch<S> | null {
  const location = useLocation();
  return useMemo(() => matchAnyPath(paths, location.pathname, end), [paths, end, location.pathname]);
}
